import { Component, OnDestroy, Inject, OnInit } from '@angular/core';
import { SuiModal, ComponentModalConfig, ModalSize, DatepickerMode } from '@richardlt/ng2-semantic-ui';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';
import { RolesService } from '../../services';
interface IRoleNewModalContext {
	data?: any;
	title?: string;
	isEdit?: boolean;
}
@Component({
	selector: 'app-role-new-modal',
	templateUrl: './role-new-modal.component.html',
	styleUrls: [ './role-new-modal.component.scss' ]
})
export class RoleNewModalComponent implements OnInit, OnDestroy {
	searchable: boolean = true;
	public mode: DatepickerMode = 'year';
	public maxDate = new Date();
	private unsubscribe$: Subject<void> = new Subject<void>();
	formSubmitAttempt: boolean;
	success: any;
	error: any;
	pending: boolean;
	role;
	roleForm: FormGroup;
	organizationId;
	permissions: Array<any> = [];
	selectedRolePermissions: Array<any>;
	constructor(
		@Inject(DOCUMENT) private document,
		private fb: FormBuilder,
		public modal: SuiModal<IRoleNewModalContext, void, void>,
		private roleSvc: RolesService
	) {
		this.permissions = JSON.parse(window.localStorage.getItem('permissions'));
		this.organizationId = window.localStorage.getItem('organizationId');
		this.roleForm = fb.group({
			roleName: [ '' ],
			roleDescription: [ '' ]
		});
		if (this.modal.context.isEdit == true) {
			this.roleForm.patchValue(this.modal.context.data);
			this.role = this.modal.context.data;
		}
	}
	isFieldValid(field: string) {
		return (
			(!this.roleForm.get(field).valid && this.roleForm.get(field).touched) ||
			(this.roleForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	displayFormCss(field: string) {
		return {
			loading: field
		};
	}
	save() {
		this.modal.context.isEdit == true ? this.update() : this.create();
	}
	create() {
		this.formSubmitAttempt = false;
		if (this.roleForm.valid) {
			this.pending = true;
			this.roleSvc.addRoles({ organizationId: this.organizationId, body: this.roleForm.value }).subscribe(
				(res: any) => {
					this.pending = false;
					this.success = 'Role added successfully';
					setTimeout(() => {
						this.modal.approve(res);
					}, 2000);
				},
				(error) => {
					this.pending = false;
					this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
				}
			);
		} else {
			this.formSubmitAttempt = true;
		}
	}

	update() {
		this.formSubmitAttempt = false;
		if (this.roleForm.valid) {
			this.pending = true;
			this.roleSvc
				.updateRoles({
					organizationId: this.organizationId,
					roleId: this.role.roleId,
					body: { ...this.role, ...this.roleForm.value }
				})
				.subscribe(
					(res: any) => {
						this.pending = false;
						this.success = 'Role updated successfully';
						setTimeout(() => {
							this.modal.approve(res);
						}, 2000);
					},
					(error) => {
						this.pending = false;
						this.error = error.error.errorMessage ? error.error.errorMessage
                                                  : error.error ? error.error
                                                  : error;
					}
				);
		} else {
			this.formSubmitAttempt = true;
		}
	}
	nullify() {
		this.success = null;
		this.error = null;
	}
	ngOnInit() {
		// this.document.body.classList.remove('panel');
	}
	// s
	ngOnDestroy(): void {
		// this.document.body.classList.add('panel');
	}
}

export class RoleNewModal extends ComponentModalConfig<IRoleNewModalContext, void, void> {
	constructor(title: string, data: any, isEdit: boolean, size: ModalSize = ModalSize.Small) {
		super(RoleNewModalComponent, { title, data, isEdit });

		this.isClosable = false;
		this.transitionDuration = 200;
		this.transition = 'slide left';
		this.size = size;
		this.isFullScreen = false;
		this.isInverted = false;
	}
}
